import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/abnormal'
/** 获取异常类型 */
export const getAbnormalTypes = () => {
  return axios.get(`${rootApi}`)
}
export const getAbnormalTypesgetTree = () => {
  return axios.get(`${rootApi}/workOrderAbnormalTree`)
}
/** 获取异常项目 */
export const getAbnormalItems = (parentId) => {
  return axios.get(`${rootApi}/${parentId}`)
}

/** 异常上报 */
export const abnormalAlarm = (params) => {
  return axios.post(`${rootApi}/alarm`, params , {dataType: 'json'})
}

/** 异常记录分页 */
export const abnormalAlarmPage = (params) => {
  return axios.get(`${rootApi}/alarm/page`, {params})
}

/** 异常报警状态枚举 */
export const alarmStatusEnums = () => {
  return axios.get(`${rootApi}/alarm/statusEnums`)
}

/** 响应异常 */
export const abnormalAlarmResponse = (params) => {
  return axios.post(`${rootApi}/alarm/response`, params , {dataType: 'json'})
}

/** 解除异常 */
export const abnormalAlarmRelieve = (params) => {
  return axios.post(`${rootApi}/alarm/relieve`, params , {dataType: 'json'})
}

/** 异常数量 */
export const abnormalAlarmNum = (params) => {
  return axios.post(`${rootApi}/alarm/abnormalAlarm`, params , {dataType: 'json'})
}